import ConfigurationService from '@/api/client/configurations.service'
import { setActiveCurrency } from '@/utils/currency'

export default {
  state: {
    configurationList: {},
  },
  getters: {
    configuration: state => state.configurationList,
  },
  actions: {
    async getConfigurations({ commit }) {
      const response = await ConfigurationService.getConfigurations()
      commit('setConfigurations', response)
      if (response && response.clientConfiguration) {
        setActiveCurrency(response.clientConfiguration.currency)
      }
    },
  },
  mutations: {
    setConfigurations: (state, configurations) => {
      state.configurationList = configurations
    },
  },
}
